/**
 * Chat response-length setting (Settings → Max Tokens).
 *
 * 4096 truncated long skill reports on models that run without thinking
 * (Haiku 5.5 hit it twice in the 2026-10-22 model comparison), while models
 * with thinking on were already raised to 32000 server-side. Chat streams,
 * so a larger limit carries no timeout risk; it is a ceiling, not a target.
 */

/** Default max_tokens for a chat turn. A multiple of the slider step. */
export const DEFAULT_MAX_TOKENS = 16384;

/** Slider bounds in SettingsPage. */
export const MAX_TOKENS_MIN = 1024;
export const MAX_TOKENS_MAX = 32768;
export const MAX_TOKENS_STEP = 1024;

/** The old default. A saved 4096 is almost always that default, not a choice. */
const LEGACY_DEFAULT_MAX_TOKENS = 4096;

/**
 * The max_tokens to use from saved settings. Missing or the legacy default
 * means DEFAULT_MAX_TOKENS.
 */
export function savedMaxTokens(settings) {
  const v = settings?.maxTokens;
  if (typeof v !== 'number' || !Number.isFinite(v) || v === LEGACY_DEFAULT_MAX_TOKENS) {
    return DEFAULT_MAX_TOKENS;
  }
  return v;
}
